import {
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { DependencySummary as DependencySummaryType } from '../utils/types';

const useStyles = makeStyles(theme => ({
  upToDate: {
    color: theme.palette.type === 'dark' ? '#66bb6a' : '#2e7d32',
  },
  outdated: {
    color: theme.palette.type === 'dark' ? '#ffa726' : '#e65100',
  },
  total: {
    color: theme.palette.text.primary,
  },
}));

interface DependencySummaryProps {
  summary: DependencySummaryType;
}

export const DependencySummary = ({ summary }: DependencySummaryProps) => {
  const classes = useStyles();

  const cards = [
    { label: 'Total de Dependências', value: summary.total, className: classes.total },
    { label: 'Atualizadas', value: summary.upToDate, className: classes.upToDate },
    { label: 'Desatualizadas', value: summary.outdated, className: classes.outdated },
  ];

  return (
    <Grid container spacing={2}>
      {cards.map(card => (
        <Grid item xs={12} sm={4} key={card.label}>
          <Card>
            <CardContent>
              <Typography variant="subtitle2" color="textSecondary">
                {card.label}
              </Typography>
              <Typography variant="h4" className={card.className}>
                {card.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
